// NOTE
// Please use your own firebase details below. For more details visit: https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html

import firebase from 'firebase/app'

// Initialize Firebase
const config = {
  apiKey:            'AIzaSyBy5GiIG7HewS7qePkcnMuWU-9NoRk5Gdo',
  authDomain:        'vallerex-ineo-prod.firebaseapp.com',
  databaseURL:       'https://vallerex-ineo-prod.firebaseio.com',
  projectId:         'vallerex-ineo-prod',
  storageBucket:     'vallerex-ineo-prod.appspot.com',
  messagingSenderId: '62036394561',
  appId:             '1:62036394561:web:fd66cbbf7795ddc076bcc0',
  measurementId:     'G-MSYV1LKNHM'
}

firebase.initializeApp(config)
